// MentionedPeopleService.js — client subscribe for base mentioned-people registry

import {
  collection,
  onSnapshot,
  query,
  where,
} from 'firebase/firestore';
import { collections, db } from 'firebaseConfig';

const normalizeString = (value) => String(value || '').trim();

/**
 * Subscribe to active mentioned people for a base.
 *
 * @param {string} baseKey
 * @param {(rows: object[]) => void} onChange
 * @returns {() => void} unsubscribe
 */
export function subscribeToMentionedPeople(baseKey, onChange) {
  const cleanBaseKey = normalizeString(baseKey);
  if (!cleanBaseKey) {
    onChange?.([]);
    return () => {};
  }

  const q = query(
    collection(db, collections.mentionedPeople),
    where('baseKey', '==', cleanBaseKey),
    where('status', '==', 'active'),
  );

  return onSnapshot(q, (snapshot) => {
    const rows = snapshot.docs.map((docSnap) => {
      const data = docSnap.data() || {};
      return {
        ...data,
        key: normalizeString(data.key) || docSnap.id,
      };
    }).sort((left, right) => (
      normalizeString(left.displayName).localeCompare(normalizeString(right.displayName))
    ));
    onChange?.(rows);
  }, () => {
    onChange?.([]);
  });
}

const mentionedPeopleService = {
  subscribeToMentionedPeople,
};

export default mentionedPeopleService;
